import * as styles from "./GalleryVideo.module.css";

interface IProps {
    url: string;
}

export const GalleryVideo = (props: IProps) => {
    const {url} = props;

    return (
        <div className={styles.wrapper}>
            <div className={styles.videoContainer}>
                <iframe
                    className={styles.iframe}
                    src={url}
                    title="Video z galerii"
                    allow="encrypted-media"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                />
            </div>
        </div>
    );
};
import * as styles from "./GalleryVideo.module.css";

interface IProps {
    url: string;
}

export const GalleryVideo = (props: IProps) => {
    const {url} = props;

    return (
        <div className={styles.wrapper}>
            <div className={styles.videoContainer}>
                <iframe
                    className={styles.iframe}
                    src={url}
                    title="Video z galerii"
                    allow="encrypted-media"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                />
            </div>
        </div>
    );
};
